export const TEXT={
    Sessions:{en:"Sessions",ar:"الجلسات"},
    Going:{en:"Going",ar:"اللي رايحين"},
    Returning:{en:"Returning",ar:"اللي راجعين"},
    Missing:{en:"Missing",ar:"اللي مش موجودين"},
    Name:{en:"Name",ar:"الاسم"},
    Class:{en:"Class",ar:"الصف"},
    Address:{en:"Address",ar:"العنوان"},
    StartSession:{en:"Start Session",ar:"بدا تسجيل الجلسه"},
    EndSession:{en:"End Session",ar:"انهاء تسجيل الجلسه"},
    SaveSession:{en:"Save Session",ar:"حفظ الجلسه الحاليه"},
    LoadSession:{en:"Load Session",ar:"تحميل الجلسه المحفوظه"},
    ImportSession:{en:"Import Session",ar:"استيراد الجلسه"},
    ExportSession:{en:"Export Session",ar:"تصدير الجلسه"},
}

export default TEXT